// Feature P2: the discharge chute and the catcher. Pure data and lookups;
// mower.ts does the collision and the pickup.
//
//   Chute: a small extra collision circle beside the deck on the chute side,
//   so the footprint reaches CHUTE_EXTEND_M past the body there. Dragging it
//   along a penalty prop is a hit ("chute dragged along the fence").
//   Catcher (dischargeSide 'none'): no chute, no clippings, and loose
//   leaves/bark under the deck are bagged at CATCHER_PER_PASS per pass.

import type { DischargeSide, EquipmentModel, PropKind } from './types';
import { propShortName } from './props';

/** How far past the body the chute reaches on its side (m, × gameScale). */
export const CHUTE_EXTEND_M = 0.15;
/** Radius of the chute's collision circle (m, × gameScale). */
export const CHUTE_R_M = 0.1;
/** Share of the loose leaves under the deck a catcher bags on each pass. */
export const CATCHER_PER_PASS = 0.6;

/** A model's chute side: its own `dischargeSide`, else none with a collector, else right (mowers). */
export function dischargeSideOf(m: Pick<EquipmentModel, 'kind' | 'collector' | 'dischargeSide'>): DischargeSide {
  if (m.dischargeSide) return m.dischargeSide;
  if (m.kind !== 'mower' || m.collector) return 'none';
  return 'right';
}

/** +1 right of travel, −1 left, 0 no chute. */
export function chuteSign(side: DischargeSide | undefined): number {
  return side === 'right' ? 1 : side === 'left' ? -1 : 0;
}

/** Invoice reason for a chute hit: "chute dragged along the fence". */
export function chuteReason(kind: PropKind): string {
  return `chute dragged along the ${propShortName(kind)}`;
}
